import { css } from '@betterment/samba-styled-system/css';
import { TickLabelProps } from '@visx/axis';
import { NumberValue } from 'd3-scale';

import { ChartHighlightData } from './useChartHighlight';

type Props = { highlightData: ChartHighlightData<unknown> | null };

export const useTickLabelProps = ({ highlightData }: Props): TickLabelProps<Date | NumberValue> => {
  return (_, index) => ({
    y: 18,
    className: css({
      fontSize: '12px',
      fill: 'text.weak',
      textAnchor: index === 0 ? 'start' : 'end',
      display: highlightData ? 'none' : 'block',
    }),
  });
};
